import { apiSystemSettings } from 'utilities/http/api/leash/apiSystemSettings';

export const leashSettingsLocalDeliveryAndHubPassThruActive = async () => {
  const response = await apiSystemSettings.getLocalDeliveryAndHubPassThruActive();
  return response.isOk ? Boolean(response.json.value) : false;
};
